import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { PhoneNumbers as PhoneNumbersComponent } from '@/components/PhoneNumbers/PhoneNumbers';

export const AuthorInfoBox = styled.div`
  background: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 14px;
  padding: 25px 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    background: ${({ theme }) => theme.palette.primary.background};
    border-radius: 21px;
    padding: 20px 15px;
  }
`;

export const Price = styled(Typography.Header)`
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 25px;
`;

export const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px;
  align-items: center;
  gap: 15px;
`;

export const MainInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const WorkingHours = styled(Typography.Caption)``;

export const Link = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const GoToShopButton = styled.button`
  height: 35px;
  cursor: pointer;
  padding: 0 15px;
  border-radius: 10px;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.primary.labels};
  background: ${({ theme }) => theme.palette.secondary.border};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 0;
`;

export const SubscribeShopButton = styled(GoToShopButton)<{
  $isFavorited: boolean;
}>`
  color: ${({ theme }) => theme.palette.system.blue};
  background: ${({ theme }) => theme.palette.system.lightBlue};

  ${({ $isFavorited }) =>
    $isFavorited &&
    css`
      color: ${({ theme }) => theme.palette.primary.labels};
      background: ${({ theme }) => theme.palette.secondary.border};
    `}
`;

export const AuthorName = styled(Typography.Body)<{ $isShop: boolean }>`
  font-size: 16px;
  font-weight: ${({ $isShop }) => ($isShop ? '500' : '400')};
`;

export const Avatar = styled.img`
  border-radius: 14px;
`;

export const PhoneNumbers = styled(PhoneNumbersComponent)<{
  $hasBottomPadding?: boolean;
}>`
  padding: 25px 0 20px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 0 5px 0;
  }

  ${({ $hasBottomPadding }) =>
    !$hasBottomPadding &&
    css`
      padding-bottom: 0;
    `}
`;

export const ShopActions = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 8px;
  padding: 15px 0 20px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    border-bottom: 0.5px solid ${({ theme }) => theme.palette.secondary.border};
  }
`;

export const Address = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: nowrap;
  padding-top: 20px;
  border-top: 0.5px solid ${({ theme }) => theme.palette.secondary.border};

  & > svg {
    flex-shrink: 0;
  }
`;
